import { render, staticRenderFns } from "./albumsEdit.vue?vue&type=template&id=ff4f9850&scoped=true&"
import script from "./albumsEdit.vue?vue&type=script&lang=js&"
export * from "./albumsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff4f9850",
  null
  
)

export default component.exports